var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{key:_vm.$route.name === 'answerSheet' ? _vm.$route.fullPath + JSON.stringify(_vm.$route.params) : (_vm.$route.matched[0] ? _vm.$route.matched[0].path : _vm.$route.path)})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }